<template>
    <v-col>
        <v-row class="d-flex">
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Produtor</span>
                <span class="data-info">{{ pedido.nmProdutor }}</span>
            </span>
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">UEP</span>
                <span class="data-info">{{ pedido.nrUep }}</span>
            </span>
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Observação</span>
                <span class="data-info">{{ pedido.dsObservacao ? pedido.dsObservacao : '--' }}</span>
            </span>
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Entrega desejada</span>
                <span class="data-info">{{ pedido.dtEntregaDesejada | formataData(false, 'ddd - DD/MM') }}</span>
            </span>
            </v-row>
            <v-row class="d-flex">
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Sugestão de Ração</span>
                <span class="data-info">{{ 0 > pedido.qtSugestao ? '--' : pedido.qtSugestao + ' Kg' }}</span>
            </span>
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Tipo</span>
                <span class="data-info">{{ pedido.dsTipoRacao ? pedido.dsTipoRacao : '--' }}</span>
            </span>
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Silo disponível</span>
                <span class="data-info">{{ 0 > pedido.qtSiloDisponivel ? '--' : pedido.qtSiloDisponivel + ' Kg'}}</span>
            </span>
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Capacidade</span>
                <span class="data-info">{{ 0 > pedido.qtCapacidadeSilo ? '--' : pedido.qtCapacidadeSilo + ' Kg' }}</span>
            </span>
            <v-row class="d-flex">
            <span class="d-flex flex-column mr-6 mb-6">
                <span class="data-label">Última enviada</span>
                <span class="data-info">{{ pedido.dsUltimaEnviada  ? pedido.dsUltimaEnviada : '--' }}</span>
            </span>
            </v-row>
        </v-row>
<!-- Fields -->

        <v-form ref="camposDescricaoForm">
            <v-row>
                <v-col class="pa-0 mr-4" cols="2">
                    <span class="data-label">Previsão de entrega</span>
                    <menu-datepicker v-model="alterarDtPrevisaoEntrega" dense outlined :filled="!editarCampos"
                                     :readonly="!editarCampos" :rules="regrasDtPrevisaoEntrega" />
                </v-col>
                <v-col class="pa-0" cols="4">
                    <span class="data-label">Fábrica de rações</span>
                    <v-autocomplete v-model="alterarIdFabricaRacao" :items="listaFabricaRacao" :rules="[OBRIGATORIO]" validate-on-blur
                        item-value="idFabricaRacao" item-text="nmFabricaRacao" no-data-text="Nenhum registro encontrado"
                        color="#008EF0" outlined dense :filled="!editarCampos" :readonly="!editarCampos">
                    </v-autocomplete>
                </v-col>
                <v-col class="d-flex justify-center align-center" cols="1">
                    <span v-if="!editarCampos && !pedido.historico.dhStatusSaiuEntrega && !pedido.historico.dhStatusCancelado"
                          class="editar-label"
                          @click="$emit('update:editarCampos', true)">
                        Editar
                    </span>
                </v-col>
            </v-row>
        </v-form>
    </v-col>
</template>
<script>
import MenuDatepicker from "@/modules/pedidosRacao/components/MenuDatepicker";
import {RULES, URLS} from '@/modules/pedidosRacao/resources';
import * as moment from "moment";

export default {
    name: 'campos-descricao',
    components: {MenuDatepicker},
    computed: {
        alterarDtPrevisaoEntrega: {
            get: function() { return this.dtPrevisaoEntrega},
            set: function(v) { this.$emit('update:dtPrevisaoEntrega', v) },
        },
        alterarIdFabricaRacao: {
            get: function() { return this.idFabricaRacao},
            set: function(v) { this.$emit('update:idFabricaRacao', v) },
        },
        regrasDtPrevisaoEntrega() {
            let regras = [this.OBRIGATORIO];
            if(!this.pedido.historico.dhStatusSaiuEntrega && !this.pedido.historico.dhStatusCancelado)
                regras.push(this.MAIOR_HOJE);
            return regras;
        }
    },
    methods: {
        ...RULES
    },
    filters: {
        formataData(date, ISO, formatoSaida) {
            let tipoData = ISO ? moment.ISO_8601 : 'YYYY-MM-DD';
            const parsedDate = moment(date, tipoData);
            if (!parsedDate.isValid()) return "";
            return parsedDate.format(formatoSaida);
        },
    },
    props: {
        pedido: {},
        editarCampos: Boolean,
        idFabricaRacao: Number,
        dtPrevisaoEntrega: String,
        listaFabricaRacao: {
            type: Array,
            require: true
        },
    }
}
</script>
<style scoped lang="scss">
@import "../../sass/variables.scss";

.data-info {
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: $gray-200;
  text-transform: capitalize;
}

.data-label {
  text-align: left;
  font: normal normal normal 10px/13px Roboto;
  letter-spacing: 0;
  color: $gray-300;
  opacity: 1;
}

.editar-label {
  font: normal 400 normal 16px/21px Roboto;
  letter-spacing: 0;
  color: $gray-300;
  opacity: 1;
  user-select: none;
  cursor: pointer;
}
</style>